<template>
  <div>
    <div class="billInfo">
      <el-row>
        <el-col :span="8">待审核金额 ：{{ reconcileBill.unaudittedAmount || '-' }}</el-col>
        <el-col :span="8">已开票金额：{{ reconcileBill.amountWithInvoices || '-' }}</el-col>
        <el-col :span="8">待开票金额：{{ reconcileBill.amountWithoutInvoices || '-' }}</el-col>
      </el-row>
    </div>
    <el-table
      v-loading="isLoading"
      :data="reconcileBill.invoiceList || []"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
        :selectable="(row, index) => canUploadInvoice && row.payOrderStatus === '待录入发票'"
      />
      <el-table-column prop="payOrderId" label="付款单号" fixed width="170" />
      <!--          <el-table-column prop="supplier" label="合作商名称" width="150"></el-table-column>-->
      <el-table-column prop="invoiceHeader" label="发票抬头" width="150" />
      <el-table-column prop="invoiceType" label="发票类型" width="120" />
      <el-table-column prop="amountWithTax" label="开票含税金额" width="100" />
      <el-table-column prop="taxRate" label="税率" />
      <el-table-column prop="pay" label="是否支付" />
      <el-table-column prop="payOrderStatus" label="付款单状态" />
      <el-table-column prop="invoiceSubmitted" label="是否已提交发票" width="120">
        <template slot-scope="scope">
          <span style="color: red; font-weight: bold">{{ scope.row.invoiceSubmitted }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="anticipatePayDate" label="预计付款日期" width="150" />
      <el-table-column prop="createdTime" label="生成时间" width="150" />
      <el-table-column label="操作" fixed="right" width="80">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="downloadBill(scope.row.payOrderId)"
            :loading="isLoading"
            :disabled="scope.row.stateDesc === '已锁定'"
            >下载</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="btn-wrap">
      <div class="btn">
        <el-button @click="downloadTpl">下载发票上传模板</el-button>
        <el-button @click="showImportDialog" :disabled="!selectedRows.length || !canUploadInvoice"
          >批量发票上传(.xls, .xlsx, 小于10M)</el-button
        >
        <el-button
          type="primary"
          @click="showAddInvoice"
          :loading="isLoading"
          :disabled="!selectedRows.length || !canUploadInvoice"
          >录入发票</el-button
        >
      </div>
    </div>

    <!--       已录入发票 保留-->
    <div class="billInfo">
      <el-row>
        <el-col :span="24"
          >已录入发票<span style="color: red"
            >（*重要：发票录入完成后，请勿忘记点击“提交发票”按钮，否则影响支付进度）</span
          ></el-col
        >
      </el-row>
    </div>
    <el-table v-loading="isLoading" :data="addedInvoices">
      <el-table-column prop="invoiceDate" label="开票日期" fixed width="100" />
      <el-table-column prop="invoiceCode" label="发票代码" width="120" />
      <el-table-column prop="invoiceNo" label="发票编号" width="120" />
      <el-table-column prop="verifyCode" label="校验码后6位" width="120" />
      <el-table-column prop="invoiceHeader" label="发票抬头" width="150" />
      <el-table-column prop="invoiceType" label="发票类型" width="110" />
      <el-table-column prop="untaxedAmount" label="未税金额" />
      <el-table-column prop="taxRate" label="税率(%)" />
      <el-table-column prop="tax" label="税额" />
      <el-table-column prop="amount" label="含税金额" width="100" />
      <el-table-column prop="checkStatus" label="验票状态" />
      <el-table-column prop="errorMessage" label="错误信息" width="120" />
      <el-table-column prop="payOrders" label="关联付款单" width="165" />
      <el-table-column prop="url" label="附件">
        <template slot-scope="scope">
          <a
            v-if="scope.row.url.toString().indexOf('http') > -1"
            :href="scope.row.url"
            target="_blank"
            >查看</a
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            type="text"
            :disabled="false"
            @click="checkInvoice(scope.row)"
            :loading="isLoading"
            >验证发票</el-button
          >
          <el-button
            type="text"
            :disabled="!canUploadInvoice && scope.row.payOrderStatus !== '已取消'"
            @click="deleteInvoice(scope.row)"
            :loading="isLoading"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="btn-wrap">
      <div class="btn">
        <el-button
          type="primary"
          :disabled="!addedInvoices.length"
          @click="submitInvoice"
          :loading="isLoading"
          >提交发票</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
export default {
  // inject: ['bill', 'invoices'],
  // props: {
  //   reconcileBill: {
  //     type: Object,
  //     default: () => {}
  //   },
  //   addedInvoices: {
  //     type: Array,
  //     default: () => []
  //   }
  // },
  data() {
    return {
      reconcileBill: {},
      addedInvoices: [],
    }
  },
  created() {
    console.log(1111)
    console.log('created', this.reconcileBill)
  },
  computed: {
    // reconcileBill() {
    //   return this.bill()
    // },
    // addedInvoices() {
    //   return this.invoices()
    // }
  },
}
</script>

<style></style>
